<script>
import { mapActions } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      auth: {
        email: "super_admin@mworld.ae",
        password: "123456",
      },
      processing: false,
      submitted: false,
      pending: false,
      error: "",
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  methods: {
    ...mapActions({
      signIn: "auth/login",
    }),
    async login() {
      this.processing = true;
      this.submitted = true;
      await axios
        .post(process.env.VUE_APP_BASE_URL+`/api/Auth/login`, this.auth)
        .then(({ data }) => {
          this.submitted = false;
          console.log(data)
          if(data.status == 0){
            this.error = data.message;
          }else{
            this.submitted = false;
            this.signIn(data.rep);
          }
        })
    },
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row no-gutters">
        <div class="col-lg-4">
          <div
            class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
          >
            <div class="w-100">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <div>
                    <div class="text-center">
                      <div class="logo">
                        <img
                          :src="require('@/assets/images/auth-logo.jpeg').default"
                          alt="Logo"
                        />
                      </div>

                      <h4 class="font-size-18 mt-4">Welcome Back !</h4>
                      <p class="text-muted">Sign in to continue ...</p>
                    </div>

                    <b-alert
                      variant="danger"
                      class="mt-3"
                      v-if="error"
                      show
                      dismissible
                      >{{ error }}</b-alert
                    >
                    <div class="p-2 mt-5">
                      <form
                        action="javascript:void(0)"
                        method="post"
                        class="form-horizontal"
                      >
                        <div class="form-group auth-form-group-custom mb-4">
                          <i class="ri-mail-line auti-custom-input-icon"></i>
                          <label for="email">Email</label>
                          <input
                            type="email"
                            v-model="auth.email"
                            class="form-control"
                            id="email"
                            placeholder="Enter email"
                          />
                        </div>

                        <div class="form-group auth-form-group-custom mb-4">
                          <i class="ri-lock-2-line auti-custom-input-icon"></i>
                          <label for="userpassword">Password</label>
                          <input
                            v-model="auth.password"
                            type="password"
                            class="form-control"
                            id="userpassword"
                            placeholder="Enter password"
                          />
                        </div>
                        <div class="mt-4 text-center">
                          <button
                            class="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            :disabled="processing"
                            @click="login"
                          >
                            <span
                              v-show="submitted || pending"
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span v-show="!submitted && !pending">Login</span>
                          </button>
                        </div>
                      </form>
                    </div>

                    <div class="mt-3 text-center">
                      <p>
                        Copyright © Directorate of Town Planning<br /> and Survey Sharjah DTPS {{ currentYear }},<br />
                        All Rights Reserved.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="authentication-bg">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.logo img {
  width: 200px;
}
h4 {
  margin-top: 0 !important;
}
.authentication-bg .bg-overlay {
  background-color: transparent;
}
</style>